<template>
  <div class="row" :class="errorClass" v-if="displayField">
    <div class="col-md-4 col-lg-4 col-xl-3 text-right">
      <label class="h6 text-md-right">
        <span v-html="label"></span> <br>
        <small class="text-black-50">{{labelSecondary}}</small>
      </label>
    </div>
    <div class="col-md-8 col-lg-8 col-xl-9">
      <div class="form-group clearfix">
        <input
          class="form-control"
          v-model="textInput"
          type="text"
          v-on:change="emitContent()"
          :required="isRequired"
        >
      </div>
      <div v-if="errorClass !== ''" class="alert alert-danger mt-1" role="alert">
        Please complete this field
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'label',
    'labelSecondary',
    'isRequired',
    'displayField',
    'errorClass'
  ],
  data () {
    return {
      textInput: ''
    }
  },
  methods: {
    emitContent: function () {
      this.$emit('addedSingleTextContent', {label: this.label, content: this.textInput, validated: this.textInput.length > 0, displayField: this.displayField})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FieldSingleText.vue